import { AdminType } from '@baserow/modules/core/adminTypes'

/**
 * "Registro" en el panel de administracion de la instancia.
 *
 * Baserow cobra esto (audit log, de enterprise) y lo deja con candado. La clase
 * base, la vista de listado con paginacion y filtros, y el propio menu lateral
 * son del core, que es MIT: lo unico que falta es la tabla y la pantalla.
 *
 * Solo lo ve quien es administrador de la INSTANCIA, no de un espacio: el
 * registro cruza espacios de trabajo. El endpoint comprueba lo mismo.
 */
export class RegistroAdminType extends AdminType {
  static getType() {
    return 'registro_mg'
  }

  getIconClass() {
    return 'iconoir-list'
  }

  getName() {
    return 'Registro'
  }

  getRouteName() {
    return 'admin-registro-mg'
  }

  getOrder() {
    return 80
  }
}

/**
 * "Inicio de sesión con Google" en el panel de administración de la instancia.
 * Es la sección de "Autenticación" que enterprise deja con candado; esta
 * configura el proveedor propio (extras_mg/sso). Solo staff.
 */
export class SsoAdminType extends AdminType {
  static getType() {
    return 'sso_mg'
  }

  getIconClass() {
    return 'iconoir-log-in'
  }

  getName() {
    return 'Inicio de sesión con Google'
  }

  getRouteName() {
    return 'admin-sso-mg'
  }

  getOrder() {
    return 85
  }
}
